import React from 'react'
import { connect } from 'react-redux'
import { CollapsibleSidebar } from '@tecuity/granite-ui/CollapsibleSidebar'
import { ChatBubble } from '@tecuity/granite-ui/ChatBubble'
import { Spinner } from 'components/Loaders/Loaders'
import { setErrorToast } from '../../actions'
import { setWorkItemId, fetchAndSetWorkviewItemHistory, setDrawerShown } from '../HistorySidebar/HistorySidebarActions'
import './HistorySidebar.scss'

export let HistorySidebar = ({
  workItemId,
  ...props
}) => {
  const [sidebarContent, setSidebarContent] = React.useState([{ id: 1, action: 'History'}])
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const historyWrapperRef = React.useRef();
  let chatBubbleCount = 0; 

  const closeSidebar = () => {
    setLoading(false)
    props.setDrawerShown(false)
    props.setWorkItemId('');
  }

  React.useEffect(() => {
    if(workItemId){
      setLoading(true);
      props.fetchAndSetWorkviewItemHistory(
        workItemId,
        (itemHistory) => {
          setSidebarContent(itemHistory)
          setLoading(false);
        },
        (err) => {
          setError(err.Message)
          setErrorToast('Something went wrong while loading the work item history, please try again.')
          setLoading(false)
        }
      )
    }
  }, [workItemId, loading])

  React.useEffect(()=>{
    historyWrapperRef.current && (historyWrapperRef.current.scrollTop = historyWrapperRef.current.scrollHeight);
  }, [sidebarContent, setSidebarContent])
  
  return(
    <div className={'sidebar-wrapper history ' +  (workItemId ? 'show' : '')}>
    {
      workItemId &&
        <CollapsibleSidebar
          onClose={closeSidebar}
          width="225px"
          height="800px"
          title="History &amp; Comments"
          closeButtonIcon={<i className="fa fa-arrow-right"></i>}
        >
        {
        loading ?
          <div className="loader-wrapper animated fadeIn">
            <Spinner size="medium" themeColor="primary" />
          </div>
        :
        error ? 
          <span className='error'>{error}</span>
        :
          <div ref={historyWrapperRef} className="history-wrapper">
            {sidebarContent.map((item, i) => {
              if (item.action === 'comment') {
                chatBubbleCount++
                return (
                  <ChatBubble
                    key={i}
                    imgPosition={chatBubbleCount % 2 == 0 ? 'left' : 'right'}
                    style={{ fontSize: '17px' }}
                    customCss={`
                    > div:nth-of-type(2){
                      background-color: ${chatBubbleCount % 2 == 0 ? '#EDEDED' : '#439AFF'};
                      color: ${chatBubbleCount % 2 == 0 ? '#313234' : '#fff'};
                    }
                    `}
                    author={item.user && `${item.user.FIRST_NAME} ${item.user.LAST_NAME}`}
                    date={item.date}
                  >
                    {item.comment + ' ' + i}
                  </ChatBubble>
                )
              } else {
                return (
                  <div key={i} className="history-item">
                    <i style={{ paddingRight: '6px' }} className="fa fa-long-arrow-right"></i>
                    <div>
                      <span className="note-date">{item.date + ' - '}</span>
                      <b>{item.user && `${item.user.FIRST_NAME} ${item.user.LAST_NAME} `}</b>
                      {item.action}
                      <b>
                        {item.assignedTo &&
                          ` ${item.assignedTo.FIRST_NAME} ${item.assignedTo.LAST_NAME}`}
                      </b>
                    </div>
                  </div>
                )
              }
            })}
          </div>
        }
          <input placeholder="Add a Comment..."></input>
        </CollapsibleSidebar>
      }
    </div>
  )
}
HistorySidebar = connect(
  (state) => ({  
    workItemId: state.historySidebar.workItemId,
    drawerShown: state.historySidebar.drawerShown
  }),
  {
    setErrorToast,
    fetchAndSetWorkviewItemHistory,
    setWorkItemId,
    setDrawerShown,
  }
)(HistorySidebar)